import React from 'react';

function CollectionInnerWalkthrough({ walkthroughLink }) {   
   
     const videoId = walkthroughLink.split("embed/")[1];  
     const updatedLink = `${walkthroughLink}?vq=hd1440&autoplay=1&mute=1&controls=0&showinfo=0&loop=1&modestbranding=1&rel=0&playlist=${videoId}`;
    
    return (
        <section className="collection-inner-walkthrough-sec">
            <iframe
                className="video-iframe"
                width="100%"
                height="auto"
                src={updatedLink}
                title="Walkthrough"
                frameBorder="0"
                allow="autoplay; encrypted-media; fullscreen"
                allowFullScreen
            ></iframe>
        </section>
    );
}

export default CollectionInnerWalkthrough;
